import { spacingTheme } from './theme';
function getSpacing(name) {
    return function getSpacingFromTheme({ theme, }) {
        return theme?.components?.atoms.spacing[name] ?? spacingTheme[name];
    };
}
export const spacing = {
    spacing2: getSpacing('spacing2'),
    spacing4: getSpacing('spacing4'),
    spacing8: getSpacing('spacing8'),
    spacing16: getSpacing('spacing16'),
    spacing24: getSpacing('spacing24'),
    spacing32: getSpacing('spacing32'),
    spacing48: getSpacing('spacing48'),
    spacing64: getSpacing('spacing64'),
};
//# sourceMappingURL=spacing.js.map